import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/src/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Absence = {
  __typename?: 'Absence';
  endDate: Scalars['String'];
  finalFee?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  startDate: Scalars['String'];
};

/** Autogenerated return type of ActionReport */
export type ActionReportPayload = {
  __typename?: 'ActionReportPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
};

export type Activity = {
  __typename?: 'Activity';
  createdAt: Scalars['String'];
  dateFrom: Scalars['String'];
  dateTo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  every?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  reports?: Maybe<Array<Report>>;
  style?: Maybe<Scalars['String']>;
  tags?: Maybe<Tag>;
  timeFrom?: Maybe<Scalars['String']>;
  timeTo?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userEmail: Scalars['String'];
  userName: Scalars['String'];
  weekdays?: Maybe<Array<Scalars['Int']>>;
};

export type App = {
  __typename?: 'App';
  childDob?: Maybe<Scalars['String']>;
  childFirstName?: Maybe<Scalars['String']>;
  childLastName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parentEmail?: Maybe<Scalars['String']>;
  parentFirstName?: Maybe<Scalars['String']>;
  parentLastName?: Maybe<Scalars['String']>;
  plannedDays?: Maybe<Array<Scalars['String']>>;
  plannedStartDate?: Maybe<Scalars['String']>;
};

export type Booking = {
  __typename?: 'Booking';
  day: Scalars['String'];
  room?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['ID']>;
};

export type Capture = {
  __typename?: 'Capture';
  caption?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  date: Scalars['String'];
  errors?: Maybe<Array<Scalars['String']>>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  tags?: Maybe<Tag>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  userEmail: Scalars['String'];
  userName: Scalars['String'];
};

export type CcsPerson = {
  __typename?: 'CcsPerson';
  ccsUid: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  level?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  usualEducatorAddressLine1?: Maybe<Scalars['String']>;
  usualEducatorAddressLine2?: Maybe<Scalars['String']>;
  usualEducatorAddressPostCode?: Maybe<Scalars['String']>;
  usualEducatorAddressState?: Maybe<Scalars['String']>;
  usualEducatorAddressSuburb?: Maybe<Scalars['String']>;
};

export type Child = {
  __typename?: 'Child';
  contacts?: Maybe<Array<Contact>>;
  dateOfBirth?: Maybe<Scalars['String']>;
  everything?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructions?: Maybe<Array<ChildInstruct>>;
  lastName: Scalars['String'];
};

export type ChildInstruct = {
  __typename?: 'ChildInstruct';
  category: Scalars['String'];
  description: Scalars['String'];
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mobile?: Maybe<Scalars['String']>;
  obsPlatformAuthorised?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateAbsence */
export type CreateAbsencePayload = {
  __typename?: 'CreateAbsencePayload';
  absence?: Maybe<Absence>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateCapture */
export type CreateCapturePayload = {
  __typename?: 'CreateCapturePayload';
  captures?: Maybe<Array<Capture>>;
};

/** Autogenerated return type of CreateNote */
export type CreateNotePayload = {
  __typename?: 'CreateNotePayload';
  errors?: Maybe<Array<Scalars['String']>>;
  note?: Maybe<Note>;
};

/** Autogenerated return type of CreateSessionSale */
export type CreateSessionSalePayload = {
  __typename?: 'CreateSessionSalePayload';
  errors?: Maybe<Array<Scalars['String']>>;
  session?: Maybe<ServiceSession>;
};

/** Autogenerated return type of CreateTemplate */
export type CreateTemplatePayload = {
  __typename?: 'CreateTemplatePayload';
  errors?: Maybe<Array<Scalars['String']>>;
  template?: Maybe<Report>;
};

export type CustomTag = {
  __typename?: 'CustomTag';
  colour?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated return type of DeleteKindyhubObject */
export type DeleteKindyhubObjectPayload = {
  __typename?: 'DeleteKindyhubObjectPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteSessionSale */
export type DeleteSessionSalePayload = {
  __typename?: 'DeleteSessionSalePayload';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type Enrolment = {
  __typename?: 'Enrolment';
  bookings?: Maybe<Array<Booking>>;
  child: Child;
  childId: Scalars['ID'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent1: Parent;
  parent2?: Maybe<ParentTwo>;
  parentId: Scalars['ID'];
  startDate?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type Form = {
  __typename?: 'Form';
  answers?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  fileURL: Scalars['String'];
  gridMode?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  subject: Scalars['String'];
  submittedBy: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type LearningOutcome = {
  __typename?: 'LearningOutcome';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  system: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  actionReport?: Maybe<ActionReportPayload>;
  createAbsence?: Maybe<CreateAbsencePayload>;
  createCapture?: Maybe<CreateCapturePayload>;
  createNote?: Maybe<CreateNotePayload>;
  createSession?: Maybe<CreateSessionSalePayload>;
  createTemplate?: Maybe<CreateTemplatePayload>;
  deleteKindyhubObject?: Maybe<DeleteKindyhubObjectPayload>;
  deleteSession?: Maybe<DeleteSessionSalePayload>;
  revertReport?: Maybe<RevertReportPayload>;
  saveActivity?: Maybe<SaveActivityPayload>;
  saveCapture?: Maybe<SaveCapturePayload>;
  saveReport?: Maybe<SaveReportPayload>;
  saveTags?: Maybe<SaveTagsPayload>;
};


export type MutationActionReportArgs = {
  action: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationCreateAbsenceArgs = {
  bookingId: Scalars['String'];
  date: Scalars['String'];
  enrolmentIdSwappedTo?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCaptureArgs = {
  date: Scalars['String'];
  fileData: Scalars['String'];
  serviceId: Scalars['String'];
};


export type MutationCreateNoteArgs = {
  content: Scalars['String'];
  parentId: Scalars['String'];
  pubToKiosk: Scalars['Boolean'];
  pubToParent: Scalars['Boolean'];
};


export type MutationCreateSessionArgs = {
  enrolmentId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationCreateTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteKindyhubObjectArgs = {
  objId: Scalars['Int'];
  objType: Scalars['String'];
};


export type MutationDeleteSessionArgs = {
  enrolmentId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationRevertReportArgs = {
  id: Scalars['Int'];
  versionId: Scalars['Int'];
};


export type MutationSaveActivityArgs = {
  activityId?: InputMaybe<Scalars['ID']>;
  dateFrom: Scalars['String'];
  dateTo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  every?: InputMaybe<Scalars['Int']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  serviceId: Scalars['String'];
  style?: InputMaybe<Scalars['String']>;
  timeFrom?: InputMaybe<Scalars['String']>;
  timeTo?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  weekdays: Array<Scalars['Int']>;
};


export type MutationSaveCaptureArgs = {
  caption?: InputMaybe<Scalars['String']>;
  captureId: Scalars['ID'];
  serviceId: Scalars['String'];
};


export type MutationSaveReportArgs = {
  content?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  reportId?: InputMaybe<Scalars['ID']>;
  serviceId: Scalars['String'];
  smartFormSubmissionIds?: InputMaybe<Array<Scalars['Int']>>;
  theme?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSaveTagsArgs = {
  children?: InputMaybe<Array<Scalars['Int']>>;
  customTags?: InputMaybe<Array<Scalars['Int']>>;
  learningOutcomes?: InputMaybe<Array<Scalars['Int']>>;
  newCustomTags?: InputMaybe<Array<Scalars['String']>>;
  nextActivities?: InputMaybe<Array<Scalars['Int']>>;
  objId: Scalars['Int'];
  objType: Scalars['String'];
  rooms?: InputMaybe<Array<Scalars['Int']>>;
};

export type Note = {
  __typename?: 'Note';
  ackAt?: Maybe<Scalars['String']>;
  ackBy?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdByName: Scalars['String'];
  id: Scalars['ID'];
  parentId: Scalars['String'];
  parentName: Scalars['String'];
  reply?: Maybe<Scalars['String']>;
};

export type Parent = {
  __typename?: 'Parent';
  balance?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  everything?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  payments?: Maybe<Array<Payment>>;
  phone?: Maybe<Scalars['String']>;
};


export type ParentBalanceArgs = {
  dateTo?: InputMaybe<Scalars['String']>;
};


export type ParentPaymentsArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};

export type ParentTwo = {
  __typename?: 'ParentTwo';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  paymentDate: Scalars['String'];
  transactionDate: Scalars['String'];
};

/** The query root of this schema */
export type Query = {
  __typename?: 'Query';
  /** Find a service by ID */
  service: Service;
};


/** The query root of this schema */
export type QueryServiceArgs = {
  id: Scalars['ID'];
};

export type Report = {
  __typename?: 'Report';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  date: Scalars['String'];
  history?: Maybe<Array<ReportEvent>>;
  id: Scalars['ID'];
  isTemplate?: Maybe<Scalars['Boolean']>;
  smartFormSubmissionIds?: Maybe<Array<Scalars['Int']>>;
  status: Scalars['String'];
  tags?: Maybe<Tag>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userEmail: Scalars['String'];
  userName: Scalars['String'];
};

export type ReportEvent = {
  __typename?: 'ReportEvent';
  createdAt: Scalars['String'];
  event: Scalars['String'];
  id: Scalars['ID'];
  userEmail: Scalars['String'];
  userName: Scalars['String'];
};

/** Autogenerated return type of RevertReport */
export type RevertReportPayload = {
  __typename?: 'RevertReportPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  report?: Maybe<Report>;
};

export type Room = {
  __typename?: 'Room';
  fdcEducatorId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inactive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SaveActivity */
export type SaveActivityPayload = {
  __typename?: 'SaveActivityPayload';
  activity?: Maybe<Activity>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of SaveCapture */
export type SaveCapturePayload = {
  __typename?: 'SaveCapturePayload';
  capture?: Maybe<Capture>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of SaveReport */
export type SaveReportPayload = {
  __typename?: 'SaveReportPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  report?: Maybe<Report>;
};

/** Autogenerated return type of SaveTags */
export type SaveTagsPayload = {
  __typename?: 'SaveTagsPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  activities?: Maybe<Array<Activity>>;
  applications?: Maybe<Array<App>>;
  bookedSessions?: Maybe<Array<ServiceSession>>;
  captures?: Maybe<Array<Capture>>;
  customTags?: Maybe<Array<CustomTag>>;
  educators?: Maybe<Array<CcsPerson>>;
  enrolments: Array<Enrolment>;
  formConfig: Scalars['String'];
  forms?: Maybe<Array<Form>>;
  hasPaymentGateway?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  learningOutcomes?: Maybe<Array<LearningOutcome>>;
  name: Scalars['String'];
  notes?: Maybe<Array<Note>>;
  report?: Maybe<Report>;
  reports?: Maybe<Array<Report>>;
  rooms: Array<Room>;
  sessions?: Maybe<Array<ServiceSession>>;
  sessionsAvailable?: Maybe<Array<ServiceSession>>;
  staffAtts?: Maybe<Array<StaffAtt>>;
  type: Scalars['String'];
  tzName?: Maybe<Scalars['String']>;
};


export type ServiceActivitiesArgs = {
  children?: InputMaybe<Array<Scalars['Int']>>;
  customTags?: InputMaybe<Array<Scalars['Int']>>;
  dateFrom: Scalars['String'];
  dateTo?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  learningOutcomes?: InputMaybe<Array<Scalars['Int']>>;
  rooms?: InputMaybe<Array<Scalars['Int']>>;
};


export type ServiceApplicationsArgs = {
  status: Scalars['String'];
};


export type ServiceBookedSessionsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  roomId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type ServiceCapturesArgs = {
  children?: InputMaybe<Array<Scalars['Int']>>;
  customTags?: InputMaybe<Array<Scalars['Int']>>;
  dateFrom: Scalars['String'];
  dateTo?: InputMaybe<Scalars['String']>;
  learningOutcomes?: InputMaybe<Array<Scalars['Int']>>;
  rooms?: InputMaybe<Array<Scalars['Int']>>;
};


export type ServiceEnrolmentsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type ServiceFormsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  updatedSince?: InputMaybe<Scalars['String']>;
};


export type ServiceNotesArgs = {
  createdSince?: InputMaybe<Scalars['String']>;
};


export type ServiceReportArgs = {
  id: Scalars['Int'];
};


export type ServiceReportsArgs = {
  children?: InputMaybe<Array<Scalars['Int']>>;
  customTags?: InputMaybe<Array<Scalars['Int']>>;
  dateFrom: Scalars['String'];
  dateTo?: InputMaybe<Scalars['String']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  learningOutcomes?: InputMaybe<Array<Scalars['Int']>>;
  rooms?: InputMaybe<Array<Scalars['Int']>>;
};


export type ServiceSessionsArgs = {
  date?: InputMaybe<Scalars['String']>;
  room?: InputMaybe<Scalars['String']>;
};


export type ServiceSessionsAvailableArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  enrolmentId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type ServiceStaffAttsArgs = {
  date: Scalars['String'];
};

export type ServiceSession = {
  __typename?: 'ServiceSession';
  absent?: Maybe<Scalars['Boolean']>;
  bookingId?: Maybe<Scalars['String']>;
  childFirstName?: Maybe<Scalars['String']>;
  childId?: Maybe<Scalars['ID']>;
  childLastName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  enrolmentId?: Maybe<Scalars['ID']>;
  fee?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['String']>;
  sessionCodeId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type StaffAtt = {
  __typename?: 'StaffAtt';
  date: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  in: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  out: Scalars['String'];
  roomName?: Maybe<Scalars['String']>;
  unpaid: Scalars['Boolean'];
};

export type Tag = {
  __typename?: 'Tag';
  children?: Maybe<Array<Scalars['Int']>>;
  customTags?: Maybe<Array<Scalars['Int']>>;
  learningOutcomes?: Maybe<Array<Scalars['Int']>>;
  nextActivities?: Maybe<Array<Scalars['Int']>>;
  rooms?: Maybe<Array<Scalars['Int']>>;
};

export type GetSmartCentralChildEnrolmentsQueryVariables = Exact<{
  srvId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetSmartCentralChildEnrolmentsQuery = { __typename?: 'Query', service: { __typename?: 'Service', enrolments: Array<{ __typename?: 'Enrolment', id: string, childId: string, status: string, startDate?: string | null, endDate?: string | null, child: { __typename?: 'Child', id: string, firstName: string, lastName: string, gender?: string | null, dateOfBirth?: string | null, everything?: string | null }, parent1: { __typename?: 'Parent', id: string, firstName: string, lastName: string, everything?: string | null } }> } };

export type GetSmartCentralEducatorsQueryVariables = Exact<{
  srvId: Scalars['ID'];
}>;


export type GetSmartCentralEducatorsQuery = { __typename?: 'Query', service: { __typename?: 'Service', educators?: Array<{ __typename?: 'CcsPerson', ccsUid: string, email?: string | null, firstName: string, lastName: string, level?: string | null }> | null } };


export const GetSmartCentralChildEnrolmentsDocument = gql`
    query getSmartCentralChildEnrolments($srvId: ID!, $startDate: String, $endDate: String) {
  service(id: $srvId) {
    enrolments(startDate: $startDate, endDate: $endDate) {
      id
      childId
      status
      startDate
      endDate
      child {
        id
        firstName
        lastName
        gender
        dateOfBirth
        everything
      }
      parent1 {
        id
        firstName
        lastName
        everything
      }
    }
  }
}
    `;
export const GetSmartCentralEducatorsDocument = gql`
    query getSmartCentralEducators($srvId: ID!) {
  service(id: $srvId) {
    educators {
      ccsUid
      email
      firstName
      lastName
      level
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getSmartCentralChildEnrolments(variables: GetSmartCentralChildEnrolmentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSmartCentralChildEnrolmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSmartCentralChildEnrolmentsQuery>(GetSmartCentralChildEnrolmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSmartCentralChildEnrolments', 'query');
    },
    getSmartCentralEducators(variables: GetSmartCentralEducatorsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSmartCentralEducatorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSmartCentralEducatorsQuery>(GetSmartCentralEducatorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSmartCentralEducators', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;